import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../../shared/components/table/Table";
import ActiveBadge from "../../../../../../shared/components/badge/ActiveBadge";
import EditPagesPermissionsDialog from "./edit/EditPagesPermissionsDialog";

const PagesPermissionsTable = ({ data, onEditionHandler }) => {
  return (
    <Table>
      <TableHeader>
        <TableHead>Ruta acceso</TableHead>
        <TableHead>Permitir acceso</TableHead>
        <TableHead>Permitir creación</TableHead>
        <TableHead>Permitir edición</TableHead>
        <TableHead>Permitir borrado</TableHead>
        <TableHead></TableHead>
      </TableHeader>
      <TableBody>
        {data &&
          data.map((row) => (
            <TableRow key={`pages_${row.path}`}>
              <TableCell>{row.path}</TableCell>
              <TableCell>
                <ActiveBadge booleanValue={row.hasAccess} />
              </TableCell>
              <TableCell>
                <ActiveBadge booleanValue={row.canCreate} />
              </TableCell>
              <TableCell>
                <ActiveBadge booleanValue={row.canEdit} />
              </TableCell>
              <TableCell>
                <ActiveBadge booleanValue={row.canDelete} />
              </TableCell>
              <TableCell>
                <EditPagesPermissionsDialog
                  onSubmitHandler={onEditionHandler}
                  pageRoute={row}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default PagesPermissionsTable;
